/**
 * Shared rendering for the document register (the folder view itself is
 * features/documents/RegisterPanel.tsx).
 *
 * The register is shown in two places — the compliance overview and an individual
 * employee's page — and they have to agree. A document that reads "In scadenza · 12 gg"
 * on one screen and "Valido" on the other is worse than showing it once.
 */

import type { RegisterItem } from '@/lib/api';
import { useI18n } from '@/i18n';
import { useLabel } from '@/lib/useLabel';

import { Badge } from './ui';

export function RegisterStatusBadge({ item }: { item: RegisterItem }) {
  const { t } = useI18n();
  const L = useLabel();
  const spec = L('register', item.status);

  // The day count only means something while a deadline is in play. On a valid or
  // missing document it is noise.
  const suffix =
    (item.status === 'expiring' || item.status === 'expired') && item.daysLeft !== null
      ? item.daysLeft < 0
        ? ` · ${t('common.daysAgo', { count: Math.abs(item.daysLeft) })}`
        : ` · ${t('common.daysLeft', { count: item.daysLeft })}`
      : '';

  return (
    <Badge tone={spec.tone}>
      {spec.label}
      {suffix}
    </Badge>
  );
}
